import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Start every page at the top.
 *
 * A browser resets the scroll position when it loads a document. React Router never
 * loads one - it swaps which components render and leaves the document alone - so the
 * scroll position is simply whatever it was, and opening a record from halfway down a
 * long listing dropped you halfway down the record. React Router leaves this to the app
 * on purpose: "always jump to the top" is wrong for some navigations, so there is no
 * sensible default it could pick.
 *
 * Keyed on the PATH only. These listings put their tab in the query string
 * (`?type=payment`), and switching tab is not going to a new page - yanking the table
 * back to the top while somebody is reading it would be worse than leaving it.
 */
export default function CommonScrollToTop() {
    const { pathname } = useLocation()

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    }, [pathname])

    return null
}
